import { render } from "./CardModal.vue?vue&type=template&id=51763400"
import script from "./CardModal.vue?vue&type=script&lang=js"
export * from "./CardModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/denis/Documents/Работа/bitbucket/mifab/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__